<template>
<div><br>
<div class="container">

  <div class="columns">
    <div class="column">
      {{this.tourInformation.data[0].nombre}} 
    </div>
    <div class="column">
      <router-link tag="button" class="button" to="/servicios/"> <font-awesome-icon icon="users" /> Ver todos los servicios</router-link>
    </div>
  </div>

  <div v-if="tiposList!='no hay datos'" class="tabs is-toggle is-toggle-rounded">
    <ul>

      <div v-for="(tipo, index) in tiposList">
        <li @click="setTipo(tipo.id,index)" style="margin-right:10px;" :class="(subSelect == index) ? 'is-active' : '' ">
          <a>
            <span v-text="tipo.nombre"></span>
          </a>
        </li>
      </div>

    </ul>
  </div>
  <div class="columns">
    <div class="column">
      <textarea class="textarea" v-model="descripcion" placeholder="Descripción"></textarea>
    </div>
    <div class="column">
            <textarea class="textarea" v-model="recomendaciones" placeholder="Recomendaciones"></textarea>
    </div>
  </div>

  <div class="columns">
    <div class="column">
      <textarea class="textarea" v-model="incluye" placeholder="Qué incluye"></textarea>
    </div>
    <div class="column">
      <textarea class="textarea" v-model="noIncluye" placeholder="No incluye"></textarea>
    </div>
  </div>

  <div class="columns">
    <div class="column">
      Lugar de salida
      <input class="input" v-model="lugarSalida">
    </div>
    <div class="column">
      <!-- Hora de salida
      <input class="input" v-model="horaSalida" type="time" > -->

      <!-- <div class="field"> -->
        Hora de salida
        <vue-clock-picker class="time" mode="24" v-model="horaSalida"></vue-clock-picker>
      <!-- </div>
       -->
    </div>
  </div>

  <div class="columns" style="background-color:#DADADA;">
    <div class="column">
      Cantidades a reportar - Mexicanos
        <div class="columns">
          <div class="column">
            <input class="input" v-model="reportarAdulto" placeholder="Adulto">
          </div>
          <div class="column">
            <input class="input" v-model="reportarMenor" placeholder="Menor">
          </div>
          <div class="column">
            <input class="input" v-model="reportarInfante" placeholder="Infante">
          </div>
        </div>

        Cantidades que los afiliados comisionan
        <div class="columns">
          <div class="column">
            <input class="input" v-model="comisionAdulto" placeholder="Adulto">
          </div>
          <div class="column">
            <input class="input" v-model="comisionMenor" placeholder="Menor">
          </div>
          <div class="column">
            <input class="input" v-model="comisionInfante" placeholder="Infante">
          </div>
        </div>

        Cantidades a ganar
        <div class="columns">
          <div class="column">
            <input class="input" v-model="gananciaAdulto" placeholder="Adulto">
          </div>
          <div class="column">
            <input class="input" v-model="gananciaMenor" placeholder="Menor">
          </div>
          <div class="column">
            <input class="input" v-model="gananciaInfante" placeholder="Infante">
          </div>
        </div>
    </div>
    <div class="column">
      <div class="columns">
        <div class="column">
          <div class="field">
            <label>Días de anticipación</label><br>
            <div class="select is-fullwidth">
              <select v-model="diasAnticipacion">
                <!-- <option class="is-size-7" v-for="tour in toursList" :key="tour.id" :value="tour">{{tour.nombre}}</option> -->
                <option class="is-size-7" value="1">1</option>
                <option class="is-size-7" value="2">2</option>
                <option class="is-size-7" value="3">3</option>
                <option class="is-size-7" value="4">4</option>
                <option class="is-size-7" value="5">5</option>
                <option class="is-size-7" value="6">6</option>
                <option class="is-size-7" value="7">7</option>
              </select>
            </div>
          </div>

          <div class="field">
            <label>Admite niños</label><br>
            <div class="select is-fullwidth">
              <select v-model="admiteNino">
                <!-- <option class="is-size-7" v-for="tour in toursList" :key="tour.id" :value="tour">{{tour.nombre}}</option> -->
                <option class="is-size-7" value="1">Sí</option>
                <option class="is-size-7" value="2">No</option>
              </select>
            </div>
          </div>

          <div class="field">
            <label>Admite infantes</label><br>
            <div class="select is-fullwidth">
              <select v-model="admiteInfante">
                <!-- <option class="is-size-7" v-for="tour in toursList" :key="tour.id" :value="tour">{{tour.nombre}}</option> -->
                <option class="is-size-7" value="1">Sí</option>
                <option class="is-size-7" value="2">No</option>
              </select>
            </div>
          </div>

        </div>
        <div class="column">
          <div class="field">
            <label>Estatus</label><br>
            <div class="select is-fullwidth">
              <select v-model="activo">
                <!-- <option class="is-size-7" v-for="tour in toursList" :key="tour.id" :value="tour">{{tour.nombre}}</option> -->
                <option class="is-size-7" value="0">Activo</option>
                <option class="is-size-7" value="1">Inactivo</option>
              </select>
            </div>
          </div>
          <div class="field">
            <label>Aplica 2x1</label><br>
            <div class="select is-fullwidth">
              <select v-model="dosPorUno">
                <!-- <option class="is-size-7" v-for="tour in toursList" :key="tour.id" :value="tour">{{tour.nombre}}</option> -->
                <option class="is-size-7" value="1">Sí</option>
                <option class="is-size-7" value="2">No</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="columns" style="background-color:#7D99CD;">
    <div class="column">
      Cantidades a reportar - Extranjeros
      <div class="columns">
          <div class="column">
            <input class="input" v-model="adultoExtranjero" placeholder="Adulto">
          </div>
          <div class="column">
            <input class="input" v-model="ninoExtranjero" placeholder="Menor">
          </div>
          <div class="column">
            <input class="input" v-model="infanteExtranjero" placeholder="Infante">
          </div>
        </div>
    </div>
  </div>

  <div class="section">

    <div class="columns" style="background-color: #D8D8D8;">
      <div class="column is-4">
      <strong>Subir Múltiples Archivos</strong>
      <!-- </div>
      <div class="column is-4"> -->
        <input class="input" type="file" id="files" ref="files" multiple v-on:change="handleFileUploads()"/>
      </div>
      <div class="column is-4">
      <!-- <button v-on:click="submitFiles2()">Subir archivos</button> -->
      <a style="margin-top: 23px;" class="button is-info" @click="submitFiles2()">Subir Archivos</a>
      </div>
    </div>

    <p><b> <font color="#758CF1"> Imágenes del servicio </font> </b></p>
    <br>
    <div class="columns" style="max-width: 80vw!important; overflow-y: scroll; overflow-x: scroll;">
      <!-- <strong><span v-text="'Imágenes...'" style="color: green;"></span></strong> -->
          <template v-if="serviceImages!=='no hay datos'" v-for="file in serviceImages">
            <!-- <div class="column is-2" align="center" v-if="file.tipo != 4 && file.tipo != 1"> -->
              <br v-if="file.descripcion!=null">
              <!-- <span v-if="file.descripcion!=null" v-text="file.descripcion"></span> -->
              <!-- <br><br> -->
              <img :src="'http://'+host_secure+'/services_images/'+file.nombre" style="margin-right:10px;" height="200" width="200">
              <a class="button is-link is-fullwidth" @click="eliminarArchivo(file.id)" style="margin-top: 5px; margin-left:-100px; margin-right:100px;" >Quitar</a>
            <!-- </div> -->
          </template>
    </div>

  </div>

<button class="button is-info" @click="upsertServicio">Actualizar</button>
</div>

<!-- ends debugging-->

  
      <div>
        
        <div id="modalConfirmacion" class="modal" align="center">
          <div class="modal-background"></div>
          <div class="modal-card">
            <header class="modal-card-head">
              <span class="modal-card-title">
                <strong>Número de confirmación</strong>
              </span>
              <button class="delete" @click="cerrarModalConfirmacion" aria-label="close"></button>
            </header>
            <section class="modal-card-body">
              <strong><span class="is-size-2" v-text="this.confirma" ></span></strong>
              <br>
              Cliente: <strong><span v-text="this.cliente"></span></strong><br>
              Vendedor: <strong><span v-text="this.vendedor"></span></strong><br>
              Tour: <strong><span v-text="this.tour.nombre"></span></strong><br>

            </section>
            <footer class="modal-card-foot">
              <button @click="cerrarModalConfirmacion" class="button is-info">Entendido</button>
            </footer>
          </div>
        </div> 

      </div>
  </div>
  

</div>
</template>

<script>

import axios from 'axios';
import qs from 'qs';
import Cors from 'cors';
import moment from 'moment';
import {SnotifyPosition, SnotifyStyle} from 'vue-snotify';
import searchMix from '../mixins/mixin.js'
// import DatePick from 'vue-date-pick'
import VueClockPicker from '@pencilpix/vue2-clock-picker'

export default {
  components:{
    // DatePick,
    VueClockPicker
  },
  data () {
    return {
      subSelect:'',
      toursList:[],
      tiposList:[],
      tiposGeneralesList:[],
      idiomasList:[],
      nacionalidadesList:[],
      salidasList:[],
      tour:'',
      tour2:'',
      tour3:'',
      tour4:'',
      tipo:'',
      nacionalidad:'',
      idioma:'',
      salida:'',
      // fecha:moment().add(1, 'day').format('YYYY-MM-DD'),
      fecha2:'',
      fecha3:'',
      fecha4:'',
      hora:'',
      searchText:'',
      searchText2:'',
      items:[],
      items2:[],
      hotel:'',
      hotelId:'',
      hotelPickup:'',
      vendedor:'',
      vendedorId:null,
      adultos:2,
      ninos:0,
      infantes:0,
      cliente:'',
      habitacion:'',
      cupon:'',
      balance:0,
      moneda:null,
      monedasList:[],
      observaciones:'',
      confirma:'',
      servicio:1,
      horario:1,
      cortesia:2,
      testObject:[],
      files: '',
      imagen: null,

      host: 'booking.sistemy.mx',
      host_secure: 'exodus.sistemy.mx',
      tourInformation:[],
      tipoElegido:'',
      servicio:'',

      descripcion:'',
      recomendaciones:'',
      incluye :'',
      noIncluye:'',

      lugarSalida:'',
      horaSalida:'',
      duracion:'',
      mapa:'',

      admiteNino:'',
      admiteInfante:'',

      reportarAdulto:'',
      reportarMenor:'',
      reportarInfante:'',
      reportarInsen:'',
      comisionAdulto:'',
      comisionMenor:'',
      comisionInfante:'',
      comisionInsen:'',
      gananciaAdulto:'',
      gananciaMenor:'',
      gananciaInfante:'',
      gananciaInsen:'',
      adultoExtranjero:'',
      ninoExtranjero:'',
      infanteExtranjero:'',

      diasAnticipacion:'',
      dosPorUno:'',
      activo:'',

      files:'',
      newFileName:'',
      serviceImage:'',
      descripcionImage:'',
      serviceImages: []
      // host: 'localhost'

    }
  },
  created(){
    console.log("path in tour",this.$route.path)
    console.log(this.$route.params.id,'<-- route')
    this.tourInfo();
    
    this.getTiposGenerales();
    this.getServiceImages();
    // this.getHoteles();
    // this.getVendedores();
    // this.getMonedas();
    // this.getTours();
    // this.getIdiomas();
    // this.getNacionalidades();
    // this.getSalidas();
  },
  computed:{
    itemsSearched : function(){
      var self = this;
      if( self.searchText == ''){
        return self.items;
      }
      return self.items.filter(function(item){

        var str = self.searchText;
        var res = str.toUpperCase();

        return item.nombre.includes(res);
      });
    },
    itemsSearched2 : function(){
      var self = this;
      if( self.searchText2 == ''){
        return self.items2;
      }
      return self.items2.filter(function(item){

        var str = self.searchText2;
        var res = str.toUpperCase();

        return item.nombre.includes(res);
      });
    }
  },
  methods:{
    eliminarArchivo (id) {
      console.log(id,"En eliminar archivo")

      var params = {
        action: 'justUpdate',
        tabla: 'services_images',
        set: 'status = 2',
        where: 'id = '+id
      }
      axios.post(`http://${this.host}/assignFunction.php`,qs.stringify(params))
      //axios.get(`http://${this.host}/assignFunction.php?action=justUpdate&tabla=${tabla}&set=${set}&where=${where}`)
          .then((response) => {
            if (response.status == 200 ) {
              console.log("eliminado & status 200")
              this.getServiceImages()
            }else{
              console.log('error');
            }
          });

    },
    getServiceImages(){
      console.log("En getServiceImages");
      var params = {
          action: 'leerpost',
          select: '*',
          table: 'services_images',
          where: 'status = 1 and servicio = '+this.$route.params.id+' order by id desc'
      }
          axios.post(`http://${this.host}/assignFunction.php`,qs.stringify(params))
          .then((response)=>{ console.log(response,'<-- response de getServiceImages')
         if (response.status == 200 ) {
          console.log("bien getServiceImages");
          this.serviceImages=response.data
         }else{
           console.log('error: no se obtuvieron las imágenes');
         }
       });

    },
    handleFileUploads(){
      this.files = this.$refs.files.files;
      console.log(files,'files')
    },
    submitFiles2(){
        
        for( var i = 0; i < this.files.length; i++ ){
          
          this.newFileName = moment().format('YYYYMMDD')+moment().format('HHmmss')+this.files[i].name
          this.serviceImage = 1 //Aquí va el id del servicio q se está editando
          this.descripcionImage = this.files[i].name
          this.saveFileData();
          var data = new FormData();
          data.append("nombre",this.newFileName)
          data.append("foto",this.files[i])
          axios.post(`http://${this.host_secure}/loadServiceImage.php`,data)
          .then(response => {
            
          })

        }

      },
      saveFileData () {
        console.log('saveFileData')
      var params = {
        action : 'insertPost',
        table : 'services_images',
        columns : 'user, fecha, hora, nombre, descripcion, servicio, status',
        values : ` ${$cookies.get('RhSession').id}, '${moment().format('YYYY-MM-DD')}', '${moment().format('HH:mm:ss')}', '${this.newFileName}', '${this.descripcionImage}', '${this.$route.params.id}', 1 `
      }
      axios.post(`http://${this.host}/assignFunction.php`,qs.stringify(params))
       .then((response)=>{
         if (response.status == 200 ) {
          //this.getCloudFileNames()
          this.getServiceImages()
          this.descripcionImage = ''
          this.imagen = ''
          this.newFileName = ''
          this.cargando = false
           this.$snotify.success('Guardado', 'Correcto', {
               timeout: 2000,
               showProgressBar: false,
               closeOnClick: false,
               pauseOnHover: true
             });
         }else{
           console.log('error: No reservado');
         }
       });
    },
    clear () {
      console.log("limpiando form");
      this.subSelect=1;
      this.tour='';
      this.tour2='';
      this.tour3='';
      this.tour4='';
      this.tipo='';
      this.nacionalidad='';
      this.idioma='';
      this.salida='';
      // this.fecha=moment().add(1, 'day').format('YYYY-MM-DD');
      this.fecha2='';
      this.fecha3='';
      this.fecha4='';
      this.hora='';
      this.searchText='';
      this.searchText2='';
      this.hotel='';
      this.hotelId='';
      this.hotelPickup='';
      this.vendedor='';
      this.vendedorId=null;
      this.adultos=2;
      this.ninos=0;
      this.infantes=0;
      this.cliente='';
      this.habitacion='';
      this.cupon='';
      this.balance=0;
      this.moneda=null;
      this.observaciones='';
      this.confirma='';
      this.servicio=1;
      this.horario=1;
      this.cortesia=2;
    },
    setTipo(id,index){
      this.subSelect = index
      this.tipoElegido = id;
      this.getServicio(id,this.$route.params.id)
      console.log(id)
    },
    tourInfo(){
      console.log("En tourInfo()");
      var params = {
          action: 'leerpost',
          select: '*',
          table: 'tour',
          where: 'id='+this.$route.params.id
      }
          axios.post(`http://${this.host}/assignFunction.php`,qs.stringify(params))
          .then((response)=>{ 
         if (response.status == 200 ) {
         this.tourInformation=response
         this.getTipos();
           this.$snotify.success('test', 'Correcto', {
               timeout: 4000,
               showProgressBar: false,
               closeOnClick: false,
               pauseOnHover: true
             });
         }else{
           console.log('error: No reservado');
         }
       });

    },
    fechas (r) {
      // if(r==2){
      //   this.fecha2=moment().add(2, 'days').format('YYYY-MM-DD');
      // }else if (r==3){
      //   this.fecha2=moment().add(2, 'days').format('YYYY-MM-DD');
      //   this.fecha3=moment().add(3, 'days').format('YYYY-MM-DD');
      // }else if(r==4){
      //   this.fecha2=moment().add(2, 'days').format('YYYY-MM-DD');
      //   this.fecha3=moment().add(3, 'days').format('YYYY-MM-DD');
      //   this.fecha4=moment().add(4, 'days').format('YYYY-MM-DD');
      // }
    },
    
    elegido:function(item){
      this.searchText='';
      this.hotel = item.nombre;
      this.hotelId = item.id;
      this.hotelPickup = item.pickup;
      console.log(this.tour.pickup,'tour.pickup');
      console.log(item,'item');
      if(this.tour.pickup=='' || this.tour.pickup==null ){
        this.hora=item.pickup;
      }
    },
    elegido2:function(item){
      this.searchText2='';
      this.vendedor = item.nombre;
      this.vendedorId = item.id;
    },
    getHoteles(){
      var estancia = this;
        // axios.post('http://localhost:3000/justRead',{
        //   select: 'id, nombre, pickup',
        //   table: 'hoteles',
        //   where: '',
        //   condition: ''
        // })
        var select = `id, nombre, pickup`;
        var tabla = "hoteles";
        var where = "";
        axios.get(`http://${this.host}/assignFunction.php?action=justRead&select=${select}&tabla=${tabla}&where=${where}`)
        .then(function(response){
          if (response.status == 200 ) {
            // estancia.hotelesList  = response.data;
            estancia.items = response.data;
          }else{
            console.log('error');
          }
        });
    },
    getMonedas(){
      var estancia = this;
        // axios.post('http://localhost:3000/justRead',{
        //   select: 'id, nombre',
        //   table: 'monedas',
        //   where: '',
        //   condition: ''
        // })
        var select = `id, nombre`;
        var tabla = "monedas";
        var where = "";
        axios.get(`http://${this.host}/assignFunction.php?action=justRead&select=${select}&tabla=${tabla}&where=${where}`)
        .then(function(response){
          if (response.status == 200 ) {
            estancia.monedasList = response.data;
            estancia.moneda=response.data[0].id;
          }else{
            console.log('error');
          }
        });
    },
    getVendedores(){
      var estancia = this;
        // axios.post('http://localhost:3000/justRead',{
        //   select: 'id, nombre',
        //   table: 'vendedores',
        //   where: 'activo=1',
        //   condition: ''
        // })
        var select = `id, nombre`;
        var tabla = "vendedores";
        var where = "activo=1";
        axios.get(`http://${this.host}/assignFunction.php?action=justRead&select=${select}&tabla=${tabla}&where=${where}`)
        .then(function(response){
          if (response.status == 200 ) {
            estancia.items2 = response.data;
          }else{
            console.log('error');
          }
        });
    },
    getTours(){
      var estancia=this;
      // axios.post('http://localhost:3000/justRead',{
      //     select:` * `,
      //     table:"tour",
      //     where:``,
      //     condition:" order by nombre "
      //   })
      var select = `*`;
      var tabla = "tour";
      var where = "";
      axios.get(`http://${this.host}/assignFunction.php?action=justRead&select=${select}&tabla=${tabla}&where=${where}`)
        .then(function(response){
          if (response.status == 200 ) {
              estancia.toursList=response.data;
          }else{
            console.log('error getTours');
          }
        }); //ends axios
    },
    getTipos(){
      console.log('en getTipos');
      // this.hora=this.tour.pickup;
      // console.log(this.hora,'hora');
      console.log(this.tourInformation.data[0].tipoBasico,'checking')
      if(this.tourInformation.data[0].tipoBasico!=2){ //Valida que el tour no deba tener tipos
        var estancia=this;
        var select = `*`;
        var tabla = "tipo";
        if(this.tourInformation.data[0].tipoBasico==1){ // Valida que el tour deba tener los tipos básico y plus
          var where = ` tourId like '%25%2C${this.$route.params.id}%2C%25' or tourId like '0'  `;
        }else{ // Hace esto en caso de que el tour no deba tener los tipo básico y plus
          var where = ` tourId like '%25%2C${this.$route.params.id}%2C%25' `;
        }
        axios.get(`http://${this.host}/assignFunction.php?action=justRead&select=${select}&tabla=${tabla}&where=${where}`)
          .then((response)=>{
            console.log(response,'response')
            if (response.status == 200 ) {
                this.tiposList=response.data;

                // this.tiposList[0].id
                // console.log(estancia.tiposList,'tiposList')
                // console.log(this.tourInformation.data[0].tipoBasico,'tipoBasico afterResponse')
                console.log('before jean')
                console.log(this.tiposList[0].id,'primer tipo en la lista')
                console.log('after jean')
                
                this.tipoElegido = this.tiposList[0].id
                this.getServicio(this.tipoElegido,this.tourInformation.data[0].id)
                
            }else{
              console.log('error getTours');
            }
          }); //ends axios
      }else{
        console.log('panda')
        this.tipoElegido=0;
        this.getServicio(this.tipoElegido,this.tourInformation.data[0].id)
      }
    },
    getTiposGenerales(){
      console.log("getTiposGenrales")
        var estancia=this;
        var select = `*`;
        var tabla = "tipo";
        var where = "tourId = '0'";
        axios.get(`http://${this.host}/assignFunction.php?action=justRead&select=${select}&tabla=${tabla}&where=${where}`)
          .then(function(response){
            if (response.status == 200 ) {
                estancia.tiposGeneralesList=response.data;
                if(estancia.tipo==''){
                  console.log(estancia.tipo,'tipo not found')
                // if(estancia.tipo=='' || (estancia.tiposList.length<1 && tour.id==6) ){
                 estancia.tipo=response.data[0].id;
                }
            }else{
              console.log('error getTours');
            }
          }); //ends axios
    },
    getServicio(tipo,tour){
      console.log(tour,"TOUR")
      if(tipo==''){
        tipo=0
      }
      console.log(tipo,tour,'tipo,tour')
      var estancia=this;
        var select = `*`;
        // var tabla = "tipo";
        var tabla = "servicios";
        var where = `tourId = ${tour} and tipoId = ${tipo}`;
        axios.get(`http://${this.host}/assignFunction.php?action=justRead&select=${select}&tabla=${tabla}&where=${where}`)
          .then((response)=>{
            console.log(response,"getServicio response")
            if (response.status == 200 ) {
              console.log(response.data[0].descripcion,'desc')
                this.servicio=response.data[0];
                this.descripcion = response.data[0].descripcion
                this.recomendaciones = response.data[0].recomendaciones
                this.incluye = response.data[0].incluye
                this.noIncluye = response.data[0].noIncluye

                this.lugarSalida = response.data[0].lugarSalida
                this.horaSalida = response.data[0].horaSalida
                this.duracion = response.data[0].duracion
                this.mapa = response.data[0].mapa

                this.admiteNino = response.data[0].admiteNino
                this.admiteInfante = response.data[0].admiteInfante

                this.reportarAdulto = response.data[0].reportarAdulto
                this.reportarMenor = response.data[0].reportarMenor
                this.reportarInfante = response.data[0].reportarInfante
                this.reportarInsen = response.data[0].reportarInsen
                this.comisionAdulto = response.data[0].comisionAdulto
                this.comisionMenor = response.data[0].comisionMenor
                this.comisionInfante = response.data[0].comisionInfante
                this.comisionInsen = response.data[0].comisionInsen
                this.gananciaAdulto = response.data[0].gananciaAdulto
                this.gananciaMenor = response.data[0].gananciaMenor
                this.gananciaInfante = response.data[0].gananciaInfante
                this.gananciaInsen = response.data[0].gananciaInsen
                this.adultoExtranjero = response.data[0].adultoExtranjero
                this.ninoExtranjero = response.data[0].ninoExtranjero
                this.infanteExtranjero = response.data[0].infanteExtranjero

                this.diasAnticipacion = response.data[0].diasAnticipacion
                this.dosPorUno = response.data[0].dosPorUno
                this.activo = response.data[0].activo

                console.log(this.servicio,'servicio')
            }else{
              console.log('error getTours');
            }
          }); //ends axios
    },
    upsertServicio(){

      var params = {
        action : 'upsert',
        request : "INSERT INTO servicios(tourId,tipoId,descripcion,recomendaciones,incluye,noIncluye,lugarSalida,horaSalida,duracion,mapa,admiteNino,admiteInfante,adultoExtranjero,ninoExtranjero,infanteExtranjero,reportarAdulto,reportarMenor,reportarInfante,reportarInsen,comisionAdulto,comisionMenor,comisionInfante,comisionInsen,gananciaAdulto,gananciaMenor,gananciaInfante,gananciaInsen,diasAnticipacion,dosPorUno,activo ) values("
        +this.$route.params.id+", "+this.tipoElegido+",'"+this.descripcion+"','"+this.recomendaciones+"','"+this.incluye+"','"+this.noIncluye+"','"+this.lugarSalida+"','"+this.horaSalida+"','"+this.duracion+"','"+this.mapa+"','"+this.admiteNino+"','"+this.admiteInfante+"','"+this.adultoExtranjero+"','"+this.ninoExtranjero+"','"+this.infanteExtranjero+"','"+this.reportarAdulto+"','"+this.reportarMenor+"','"+this.reportarInfante+"','"+this.reportarInsen+"','"+this.comisionAdulto+"','"+this.comisionMenor+"','"+this.comisionInfante+"','"+this.comisionInsen+"','"+this.gananciaAdulto+"','"+this.gananciaMenor+"','"+this.gananciaInfante+"','"+this.gananciaInsen+"','"+this.diasAnticipacion+"','"+this.dosPorUno+"','"+this.activo+
        "') on duplicate key update tourId=values(`tourId`), tipoId=values(`tipoId`), descripcion=values(`descripcion`), recomendaciones=values(`recomendaciones`), incluye=values(`incluye`), noIncluye=values(`noIncluye`), lugarSalida=values(`lugarSalida`), horaSalida=values(`horaSalida`), duracion=values(`duracion`), mapa=values(`mapa`), admiteNino=values(`admiteNino`), admiteInfante=values(`admiteInfante`), adultoExtranjero=values(`adultoExtranjero`), ninoExtranjero=values(`ninoExtranjero`), infanteExtranjero=values(`infanteExtranjero`), reportarAdulto=values(`reportarAdulto`), reportarMenor=values(`reportarMenor`), reportarInfante=values(`reportarInfante`), reportarInsen=values(`reportarInsen`), comisionAdulto=values(`comisionAdulto`), comisionMenor=values(`comisionMenor`), comisionInfante=values(`comisionInfante`), comisionInsen=values(`comisionInsen`), gananciaAdulto=values(`gananciaAdulto`), gananciaMenor=values(`gananciaMenor`), gananciaInfante=values(`gananciaInfante`), gananciaInsen=values(`gananciaInsen`), diasAnticipacion=values(`diasAnticipacion`), dosPorUno =values(`dosPorUno`), activo=values(`activo`) "
      }
      axios.post(`http://${this.host}/assignFunction.php`,qs.stringify(params))
       .then((response)=>{
         if (response.status == 200 ) {
           this.$snotify.success('Upsert', 'Correcto', {
               timeout: 2000,
               showProgressBar: false,
               closeOnClick: false,
               pauseOnHover: true
             });
         }else{
           console.log('error: No guardado en la tabla');
         }
       });

    },
    getIdiomas(){
      var estancia=this;
      // axios.post('http://localhost:3000/justRead',{
      //     select:` * `,
      //     table:"idioma",
      //     where:``,
      //     condition:""
      //   })
      var select = `*`;
      var tabla = "idioma";
      var where = ``;
      axios.get(`http://${this.host}/assignFunction.php?action=justRead&select=${select}&tabla=${tabla}&where=${where}`)
        .then(function(response){
          if (response.status == 200 ) {
              estancia.idiomasList=response.data;
              estancia.idioma=response.data[4].id;
          }else{
            console.log('error getTours');
          }
        }); //ends axios
    },
    getSalidas(){
      var estancia=this;
      // axios.post('http://localhost:3000/justRead',{
      //     select:` * `,
      //     table:"lugar_salida",
      //     where:``,
      //     condition:""
      //   })
      var select = `*`;
      var tabla = "lugar_salida";
      var where = ``;
      axios.get(`http://${this.host}/assignFunction.php?action=justRead&select=${select}&tabla=${tabla}&where=${where}`)
        .then(function(response){
          if (response.status == 200 ) {
              estancia.salidasList=response.data;
              estancia.salida=response.data[0].id;
          }else{
            console.log('error getTours');
          }
        }); //ends axios
    },
    getNacionalidades(){
      var estancia=this;
      // axios.post('http://localhost:3000/justRead',{
      //     select:` * `,
      //     table:"nacionalidad",
      //     where:``,
      //     condition:""
      //   })
      var select = `*`;
      var tabla = "nacionalidad";
      var where = ``;
      axios.get(`http://${this.host}/assignFunction.php?action=justRead&select=${select}&tabla=${tabla}&where=${where}`)
        .then(function(response){
          if (response.status == 200 ) {
              estancia.nacionalidadesList=response.data;
              estancia.nacionalidad=response.data[0].id;
          }else{
            console.log('error getTours');
          }
        }); //ends axios
    },
    tipoCuponF(n){
      if(this.tipoCupon==1){
        $("#1").addClass("is-active");
      }
      if(n==2){
        $("#2").addClass("is-active");
      }
      if(n==3){
        $("#3").addClass("is-active");
      }
      if(n==4){
        $("#4").addClass("is-active");
      }
      this.tipoCupon=n;
    },
    cerrarModalConfirmacion:function(){
      this.clear();
      $("#modalConfirmacion").removeClass("is-active");
    },
  },
  mixins: [searchMix]
}
</script>
